import GameConfig from '../GameConfig';
import State from './State';
import * as PIXI from 'pixi.js';
import {Countdown} from '../Countdown';
import {clamp} from '../../utils';
import {Loc, Location} from '../../common/map/Location';
import TargetCursor from '../TargetCursor';
import {projectileRenderer} from 'src/Pixi/map/ProjectileRenderer';
import {FireProjectile} from '../actions/FireProjectile';
import {pointerRenderer} from 'src/Pixi/PointerRenderer';

import Point = PIXI.Point;

export default class FireState extends State {
    private tile: Point;
    private countdown: Countdown;
    private cursor: TargetCursor = new TargetCursor();
    private lastTick: number;

    public start(): void {
        this.countdown = new Countdown(10, 'Fire Cannons');
        this.countdown.start();
        this.lastTick = Date.now();
        this.tile = new Point(0, 0);
        if (this.player().isAlive) {
            pointerRenderer.setPointerType('target');
        }
    }

    public finish(): void {
        projectileRenderer.clear();
        this.countdown.finish();
        if (this.player().isAlive) {
            this.cursor.finish();
        }
        this.controller.showCursor();
        this.game.resolveDamaged();
    }

    public tick(): void {
        const now = Date.now();
        const dt = now - this.lastTick;
        this.lastTick = now;
        if (this.player().isAlive) {
            this.cursor.tick(dt);
        }

        projectileRenderer.tick(this.game);
        this.countdown.tick();
    }

    public onMouseMove(pos: Point): void {
        if (this.isSpectating()) return;

        if (!this.cursor.isVisible()) {
            this.cursor.start(pos);
            this.controller.showCursor('crosshair');
        } else {
            this.cursor.setTarget(pos);
        }
        this.tile = this.tilePosition(this.cursor.sprite.position);
    }

    private tilePosition({x, y}: Loc): Point {
        const tileX = clamp(x / GameConfig.tileSize, 0, this.game.map.width - 0.01);
        const tileY = clamp(y / GameConfig.tileSize, 0, this.game.map.height - 0.01);
        return new Point(tileX, tileY);
    }

    public onMouseClick(_e: Point): void {
        if (this.countdown.durationLeft() <= 0) return;
        this.tile = this.tilePosition(this.cursor.sprite.position);
        new FireProjectile(this.game).byClient(this.tile);
    }

    public getCursorTile(): Location {
        return Location.fromPoint(this.tile);
    }
}



// WEBPACK FOOTER //
// ./src/game/states/FireState.ts